import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import Titles from './components/Titles';
import Alterations from './components/Alterations';
import Home from './components/home';
import createHistory from 'history/createHashHistory'
import Navbar from './components/Navbar';
import Login from "./components/Login";

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false
    };
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    const token = localStorage.getItem('token');
    if (token) {
      this.setState({
        loggedIn: true
      })
    }
  }

  handleLogin(status) {
    this.setState({
      loggedIn: Boolean(status)
    });
  }

  handleLogout() {
    localStorage.removeItem('token');
    this.setState({
      loggedIn: false
    })
  }

  render() {
    return (
      // <Router history={history}>
      //   <Switch>
      //     <Route exact path = "/" component={Login}/>
      //     <Route path = "/home" component={Home}/>
      //   </Switch>
      // </Router>
      <div>
        <Navbar onLogout={this.handleLogout} loggedIn={this.state.loggedIn} key={this.state.loggedIn}/>
        {this.state.loggedIn ? (
          <Alterations />
        ) : (
          <Login onLogin={this.handleLogin}/>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js